import {css} from 'styled-components';
import { devices, theme } from 'styles/theme'; // Import Style sheet


export const globalStyleTypographyColor = css`



    .subtitle-text {
        font-size: 1.5rem; /* 30px (assuming 1rem = 20px) */
        line-height: 1.8rem; /* 36px */
        letter-spacing: -0.05em; /* -5% */
     
    }


    h1 {
        font-size: ${theme.fontSizes.h1};
        font-family: ${theme.fonts.heading};
        font-weight: ${theme.fontWeights.regular};
        line-height: ${theme.lineHeights.h1};
		letter-spacing: ${theme.letterSpacing.h1};
	
    }

    h2 {
        font-size: ${theme.fontSizes.h2};
        font-family: ${theme.fonts.heading};
        font-weight: ${theme.fontWeights.regular};
        line-height: ${theme.lineHeights.h2};
        letter-spacing: ${theme.letterSpacing.h2};
	
    }

    h3 {
        font-size: ${theme.fontSizes.h3};
        font-weight: ${theme.fontWeights.regular};
        line-height: ${theme.lineHeights.h3};
        letter-spacing: ${theme.letterSpacing.h3};
		
    }

    h4 {
        font-size: ${theme.fontSizes.h4};
        font-weight: ${theme.fontWeights.regular};
    }

    h5 {
        font-size: ${theme.fontSizes.h5};
        font-weight: ${theme.fontWeights.regular};
    }

    h6 {
        font-size: ${theme.fontSizes.h6};
        font-weight: ${theme.fontWeights.regular};
    }


    a {
        transition: ${theme.transition};
        text-decoration: none;

        &:hover {
            color: ${theme.colors.hover} !important;
            text-decoration: none;
            outline: none;
            box-shadow: none;
        }

        &:focus {
            text-decoration: none;
            outline: none;
            box-shadow: none;
            color: ${theme.colors.text};
        }
    }

    ::selection {
        background: ${theme.colors.hover};
        color: #5D8D3B;
    } 
	::marker {
        color: #5D8D3B;
    }


    p, a, h1, h2, h4, h3, h5, h6 {
        font-weight: 400;
        margin: 0;
    }

    h1, h2, h3 {
        font-family: ${theme.fonts.heading};
    }


    ul {
        margin: 0;
        padding: 0
    }

    li {
        list-style: none;
    }

    img {
        max-width: 100%;
        object-fit: contain;
    }


	p{
		letter-spacing: 0;
	}

    .subtitle-eco {
        color: #ffffff;
        font-weight: 500;
        font-size: 1.5rem;
        line-height: 1.2;
        letter-spacing: -0.03em;
    }


 



`;

